<template>
  <div class="knowledge-selection">
    <div>
      <v-row class="v-knowledge-selection">
        <!----------------------------------- SELECTED VIDEO CATEGORIES --------------------------------------->
        <v-col cols="12" lg="12" class="py-0 flex-grow-1">
          <v-row>
            <v-col cols="2" class="flex-grow-1">
              <v-text-field
                v-model="searchEducation"
                filled
                :placeholder="$ucfirst($t('knowledge.searcheducation'))"
                prepend-inner-icon="mdi-magnify"
                flat
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="flex-grow-1">
              <v-card class="border py-5 px-3 vert-stretch">
                <label-picker
                  v-model="selectedCategories"
                  :labels="categories"
                  :input-label="$ucfirst($t('categories'))"
                  item-text="name"
                  showListIcons
                  :all-labels-string="
                    $ucfirst(
                      $t(
                        'knowledge.questions.startmoving.expert.whobenefits.answers.all',
                        { catalog: 'content' }
                      )
                    )
                  "
                />
              </v-card>
            </v-col>
            <v-col cols="4" class="flex-grow-1">
              <v-card class="border py-5 px-3 vert-stretch">
                <label-picker
                  v-model="selectedChoiceOf"
                  :labels="choiceOf"
                  :input-label="$ucfirst($t('knowledge.choiceof'))"
                  item-text="name"
                  item-value="key"
                  itemIcon="eva-person-outline"
                  showListIcons
                  :all-labels-string="
                    $ucfirst(
                        $t(
                          'knowledge.questions.startmoving.expert.whobenefits.answers.all',
                          { catalog: 'content' }
                        )
                      )
                  "
                />
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="py-0 flex-grow-1">
          <v-row>
            <v-col cols="8" class="flex-grow-1">
              <v-card
                class="border py-5 px-3 vert-stretch"
                :class="{'px-5 d-flex align-center': !sortedPatientDocuments.length}"
              >
                <documents-per-category
                  v-if="sortedPatientDocuments.length"
                  v-disable-all="hasReadOnlyAccess"
                  class="vert-stretch included"
                  style="max-height: 615px;"
                  :sortedPatientDocuments="sortedPatientDocuments"
                  :selectable="true"
                  :active-patient-document-id="
                    selectedPatientDocument
                      ? selectedPatientDocument.patientDocumentId
                      : null
                  "
                  :disabledIds="softSendIds"
                  @click:categoryrow="activateDocument"
                  @click:share="sendNotificationToPatient"
                  @removeChoiceOfCaregiver="updateChoiceOfCaregiver"
                />
                <div v-else-if="!isLoading">
                  <p class="mb-0">
                    {{ $ucfirst($t('learnMoreKnowledgeChallengeScreen.noContent', { catalog: 'app_mobile' })) }}
                  </p>
                </div>
              </v-card>
            </v-col>
            <v-col cols="4" class="flex-grow-1">
              <v-card
                class="border py-5 px-3 vert-stretch"
                v-if="selectedPatientDocument"
                v-click-outside="{
                  handler: onClickOutside,
                  include: include
                }"
              >
                <div>
                  <div class="v-knowledge-selection__details">
                    {{ /* selectedPatientDocument */ }}
                    <div>
                      <p class="text-cardtitle">{{ $ucfirst($t("title")) }}</p>
                      <p>{{ selectedPatientDocument.document.title }}</p>
                    </div>
                    <div>
                      <p class="text-cardtitle">
                        {{ $ucfirst($t("knowledge.contenttype")) }}
                      </p>
                      <p>
                        {{
                          getContentTypeText(
                            selectedPatientDocument.document.categories
                          )
                        }}
                      </p>
                    </div>
                    <div>
                      <p class="text-cardtitle">
                        {{ $ucfirst($t("knowledge.questionsansweredwrong")) }}
                      </p>
                      <p>{{ parseInt(selectedPatientDocument.relatedTestQuestionsWrong) }}</p>
                    </div>
                    <div>
                      <p class="text-cardtitle">
                        {{ $ucfirst($t("knowledge.sent")) }}
                      </p>
                      <p>{{ parseInt(selectedPatientDocument.timesSent) }}</p>
                    </div>
                    <div>
                      <p class="text-cardtitle">
                        {{ $ucfirst($t("knowledge.watched")) }}
                      </p>
                      <p>{{ parseInt(selectedPatientDocument.timesOpened) }}</p>
                    </div>
                  </div>
                  <div class="v-knowledge-selection__actions mt-6">
                    <v-btn
                      outlined
                      color="primary"
                      class="mr-2 mb-1"
                      @click="addToPatientFavourite()"
                      v-if="isSDMStarted && !selectedPatientDocument.recommended"
                      :disabled="hasReadOnlyAccess"
                    >
                      <v-icon left> mdi-star-outline </v-icon>
                      {{ $ucfirst($t("knowledge.addmyinfo")) }}
                    </v-btn>
                    <v-btn
                      outlined
                      color="primary"
                      class="mr-2 mb-1"
                      :disabled="this.softSendIds.includes(selectedPatientDocument.document.id) || hasReadOnlyAccess"
                      @click="sendNotificationToPatient({
                        doc: selectedPatientDocument
                      })"
                    >
                      <v-icon left> mdi-share-outline </v-icon>
                      {{ $ucfirst($t("knowledge.sendnotification")) }}
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import LabelPicker from "../../../components/Parts/LabelPicker";
import gql from "graphql-tag";
import PatientDocument from "../../../../../model/PatientDocument";
import DocumentsPerCategory from "../../../components/Parts/DocumentsPerCategory";
import { coro } from "../../../../../configuration/colors";
import { debounce } from "debounce";
import { simpleClone } from "../../../../../helper/objects";
import { mapGetters } from "vuex";

/**
 * Component PatientOverviewKnowledgeSelection.vue
 *
 * @module PatientOverviewKnowledgeSelection
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.8] app/src/APP_DASHBOARD/templates/views/Patient/Knowledge/PatientOverviewKnowledgeSelection.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "PatientOverviewKnowledgeSelection",
  components: {
    DocumentsPerCategory,
    LabelPicker,
  },
  data: (vm) => {
    return {
      searchEducation: null,
      categories: [],
      selectedCategories: [],
      selectedPatientDocuments: [],
      selectedPatientDocument: null,
      choiceOf: [
        {
          name: vm.$ucfirst(vm.$t("people.patient")),
          key: "patient",
          icon: "eva-person-outline",
          labelTextColorClass: "color-coro-purple",
          iconColor: coro.purple,
          labelBackgroundColorClass: "bg-color-coro-purpleish",
        },
        {
          name: vm.$ucfirst(vm.$t("people.caregivers")),
          key: "caregiver",
          icon: "eva-person-outline",
          labelTextColorClass: "color-coro-green",
          iconColor: coro.green,
          labelBackgroundColorClass: "bg-color-coro-lightgreen",
        },
        {
          name: vm.$ucfirst(vm.$t("people.nobody")),
          key: "nobody",
          icon: "eva-person-outline",
          labelTextColorClass: "color-coro-blue",
          iconColor: coro.blue,
          labelBackgroundColorClass: "bg-color-coro-lightblue",
        },
      ],
      selectedChoiceOf: [],
      softSendIds: [],
      timeOutSend: {},
      setInitialCategories: true,
      isLoading: true
    };
  },
  created() {
    const clone = simpleClone(this.choiceOf);
    clone.pop();
    this.selectedChoiceOf = clone;
  },
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
      hasReadOnlyAccess: "user/hasReadOnlyAccess",
      isSDMStarted: "followupSession/isSDMStarted"
    }),
    sortedPatientDocuments: function () {
      let sorted = {};

      if (this.selectedPatientDocuments.length) {
        this.selectedPatientDocuments.forEach((doc) => {
          const foundCatObj = doc.document.mainCategory;
          const foundCat = foundCatObj ? foundCatObj.key : "";

          if (foundCat != "") {
            if (!sorted[foundCat]) {
              sorted[foundCat] = {
                category: foundCatObj,
                docs: {},
              };
            }

            sorted[foundCat].docs[doc.document.id] = doc;

            doc.seen = doc.timesOpened > 0;
            // doc.documentTime = doc.openDate ? doc.openDate.format('YYYY-MM-DD') : null
          }
        });
      }

      return Object.values(sorted);
    },
  },
  mounted: function () {
    this.loadCategories();
    // before refreshing or leaving screen (app) completely
    // send all queued notifications
    window.addEventListener('beforeunload', this.sendAll)
  },
  beforeDestroy: function () {
    window.removeEventListener('beforeunload', this.sendAll);
  },
  watch: {
    searchEducation: debounce(function (value) {
      this.offset = 0;
      this.loadSelectedPatientDocuments();
    }, 500),
    selectedCategories: debounce(function (value) {
      this.offset = 0;
      // reload documents when default/initial selection has been made
      if (!this.setInitialCategories) {
        this.loadSelectedPatientDocuments();
      } else {
        this.setInitialCategories = false
      }
    }, 500),
    selectedChoiceOf: debounce(function (value) {
      this.offset = 0;
      this.loadSelectedPatientDocuments();
    }, 500),
    patientId: function () {
      this.offset = 0;
      this.loadSelectedPatientDocuments();
    },
    offset: function() {
      this.loadSelectedPatientDocuments();
    }
  },
  methods: {
    getContentTypeText: function (categories) {
      let contentTypeObjs = categories.filter((cat) => cat.type == "CONTENT_TYPE");

      return contentTypeObjs.length
        ? contentTypeObjs[0].name
        : this.$ucfirst(this.$t('categories.text.name', {catalog: 'content'}));
    },
    activateDocument: function (data) {
      if (data.doc.document.id === this.selectedPatientDocument?.document?.id) {
        this.selectedPatientDocument = null;
      } else {
        this.selectedPatientDocument = data.doc;
      }
    },
    loadSelectedPatientDocuments: function () {
      this.selectedPatientDocuments = [];
      this.selectedPatientDocument = null;

      const variables = {
        patientId: this.patientId,
      };

      let variableString = "$patientId: String!,";
      let conditionString = "";

      if (this.searchEducation) {
        variableString += "$search: String!,";
        variables.search = this.searchEducation;
        conditionString += "{ function: search, value: $search },";
      }

      // add category condition to query, if any category selected
      // otherwise all will be shown
      if (this.selectedCategories.length) {
        variableString += "$categories: [String!]!,";
        conditionString += "{ field: categoryKey, operator : in, parameters: $categories },";
        variables.categories = this.selectedCategories.map((e) => e.key);
      }

      if (this.selectedChoiceOf.length) {
        let selectedChoiceOfConditionString = "";

        const patientSelected = this.selectedChoiceOf.some((entry) => entry.key === "patient");
        const caregiverRecommended = this.selectedChoiceOf.some((entry) => entry.key === "caregiver");
        const nobody = this.selectedChoiceOf.some((entry) => entry.key === "nobody");

        if (patientSelected && caregiverRecommended && nobody) {
          selectedChoiceOfConditionString = "";
        } else if (patientSelected && caregiverRecommended) {
          selectedChoiceOfConditionString = '{gate : or, inputs : [{ field: topicSelected, value: "1" }, { field: recommended, value : "1" }]}';
        } else if (caregiverRecommended && nobody) {
          selectedChoiceOfConditionString = '{gate : or, inputs: [{ field: topicSelected, value: "0" }, { field: patientDocumentId, operator: isnull }]}';
        } else if (patientSelected && nobody) {
          selectedChoiceOfConditionString = '{gate : or, inputs: [{ field: recommended, value: "0" }, { field: patientDocumentId, operator: isnull }]}';
        } else if (patientSelected) {
          selectedChoiceOfConditionString = '{ field: topicSelected, value : "1" }';
        } else if (caregiverRecommended) {
          selectedChoiceOfConditionString = '{ field: recommended, value : "1" }';
        } else if (nobody) {
          selectedChoiceOfConditionString =
            `{gate : or, inputs: [{ field: recommended, value: "0" }, { field: patientDocumentId, operator: isnull }]},
             {gate: or, inputs: [{ field: topicSelected, value: "0" }, { field: patientDocumentId, operator: isnull}] }`;
        }

        conditionString += selectedChoiceOfConditionString;
      }
      this.isLoading = true
      this.$app.apolloMobileClient
        .query({
          query: gql`
            query getSelectedPatientDocuments(${variableString}) {
              myPatientDocuments(
               functions: { function: patientId, parameters: [$patientId] }
               conditions: {
                  gate: and
                  inputs: [
                    { field: categoryKey, value: "EDUCATION" },
                    ${conditionString}
                  ]
                }
              ) {
                patientDocumentId
                relatedTestQuestionsRight
                relatedTestQuestionsWrong
                timesOpened
                timesSent
                openDate
                favoured
                recommended
                topicSelected
                document {
                  id
                  title

                  mainCategory {
                    id
                    key
                    name
                    type
                  }

                  categories {
                    id
                    key
                    name
                    type
                  }
                }
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          this.selectedPatientDocuments = result.data.myPatientDocuments.map(
            (pdData) => new PatientDocument(pdData)
          );

          if (this.selectedPatientDocuments.length)
            this.selectedPatientDocument = this.selectedPatientDocuments[0];

          if (this.setInitialCategories) {
            this.selectedCategories = this.sortedPatientDocuments
              .map(item => ({key:item.category.key, name:item.category.name}))
          }
        })
        .finally(() => {
          this.isLoading = false
        });
    },

    loadCategories: function () {
      this.$app.knowledgeManager.getKnowledgeCategories(this.patientId).then((categories) => {
        this.categories = categories.map(item => item.category);
      });
    },

    addToPatientFavourite: function () {
      this.$app.apolloMobileClient
        .mutate({
          mutation: gql`
            mutation updateMyPatientDocument(
              $patientId: Int!
              $favoured: Boolean!
              $docId: String!
            ) {
              updateMyPatientDocument(
                patientDocument: {
                  id: $docId
                  patientId: $patientId
                  favoured: $favoured
                }
              ) {
                favoured
                document {
                  id
                }
              }
            }
          `,
          variables: {
            patientId: parseInt(this.patientId),
            favoured: true,
            docId: this.selectedPatientDocument.document.id,
          },
        })
        .then(() => {
          const id = this.selectedPatientDocument.document.id;
          const patientDocs = JSON.parse(JSON.stringify(this.selectedPatientDocuments))
          patientDocs.forEach(doc => {
            if (doc.document.id === id) {
              doc.favoured = true;
              return;
            }
          })
          this.selectedPatientDocuments = patientDocs;
          this.selectedPatientDocument.favoured = true;
          if (!this.selectedPatientDocument.recommended) {
            this.updateChoiceOfCaregiver(id, true)
          }
        });
    },

    updateChoiceOfCaregiver(id, add) {
      this.$app.apolloMobileClient
        .mutate({
          mutation: gql`
            mutation updateMyPatientDocument(
              $patientId: Int!
              $recommended: Boolean!
              $docId: String!
            ) {
              updateMyPatientDocument(
                patientDocument: {
                  id: $docId
                  patientId: $patientId
                  recommended: $recommended
                }
              ) {
                recommended
                document {
                  id
                }
              }
            }
          `,
          variables: {
            patientId: parseInt(this.patientId),
            recommended: add,
            docId: id,
          },
        })
        .then(() => {
          // update document list (based on filters) without refetching data
          this.updatePatientDocumentList(id, add)
        });
    },

    updatePatientDocumentList(id, add) {
      const patientDocs = JSON.parse(JSON.stringify(this.selectedPatientDocuments))
      const currentChoiceOf = this.selectedChoiceOf.map(item => item.key);
      const currentDoc = patientDocs.find(doc => doc.document.id === id);

      const keepIfRemove = currentDoc?.topicSelected && currentChoiceOf.includes('patient')
        || !currentDoc?.topicSelected && currentChoiceOf.includes('nobody')
        || !currentChoiceOf.length
      const keepIfAdd = currentDoc?.topicSelected && currentChoiceOf.includes('patient')
        || !currentDoc?.topicSelected && currentChoiceOf.includes('caregiver')
        || !currentChoiceOf.length

      // remove from list if no longer fits with the choiceOf filters
      if ((!add && !keepIfRemove) || (add && !keepIfAdd)) {
        const index = patientDocs.findIndex(doc => doc.document.id === id);
        patientDocs.splice(index, 1)
        this.selectedPatientDocuments = patientDocs;
        this.selectedPatientDocument = null;
        return;
      }

      // keep in list - update recommended value
      patientDocs.forEach(doc => {
        if (doc.document.id === id) {
          doc.recommended = add;
          return;
        }
      })
      this.selectedPatientDocuments = patientDocs;
      if (this.selectedPatientDocument?.document?.id === id) {
        this.selectedPatientDocument.recommended = add;
      }
    },

    async send(id) {
      const sent = await this.$store.dispatch('alerts/sendReminderToPatient', {
        patientId : this.patientId,
        reminderType : "VIEW_EDUCATIONAL_CONTENT",
        force : true,
        forceNotify : true,
        parameters :[
            {key: "documentUuid", value : id},
        ]
      });

      if(!sent) {
        this.toggleSentCount(id, false)
      }
      this.clearTimeoutSend(id)
    },

    async sendNotificationToPatient(data) {
      const id = data.doc.document.id;
      const contentType = data.doc.document.categories.find(item => item.type === 'CONTENT_TYPE')?.name;
      const title = data.doc.document.title;
      this.softSendIds = [...this.softSendIds, id]

      // 'Undo' toast
      this.$toasted.show(
        this.$ucfirst(
          this.$t("knowledge.notificationSent", {
            params: {
              contentType: contentType?.toLowerCase() || (this.$t('categories.text.name', {catalog: 'content'})).toLowerCase(),
              title: title
            },
          })
        ),
        {
          icon: 'undo',
          duration: 10000,
          action: {
            text: this.$ucfirst(
                this.$t("dss.undo")
            ),
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
              this.clearTimeoutSend(id)
              this.toggleSentCount(id, false)
            }
          },
        }
      )

      this.toggleSentCount(id, true)

      const timeout = setTimeout(() => {
        this.send(id);
      }, 10000);

      this.timeOutSend = {...this.timeOutSend, [id]: timeout}
    },

    clearTimeoutSend(id) {
      clearTimeout(this.timeOutSend[id]);
      this.timeOutSend[id] = null

      const index = this.softSendIds.indexOf(id)
      if (index >= 0) {
        const _softSendIds = [...this.softSendIds];
        _softSendIds.splice(index, 1)
        this.softSendIds = _softSendIds;
      }
    },

    clearAllTimeouts() {
      this.softSendIds.forEach(id => {
        clearTimeout(this.timeOutSend[id]);
      })

      this.timeOutSend = {};
      this.softSendIds = [];
    },

    toggleSentCount(id, add) {
      const patientDocs = JSON.parse(JSON.stringify(this.selectedPatientDocuments))
      patientDocs.forEach(doc => {
        if (doc.document.id === id) {
          add
            ? doc.timesSent += 1
            : doc.timesSent -= 1

          return;
        }
      })
      this.selectedPatientDocuments = patientDocs;
      if (this.selectedPatientDocument?.document?.id === id) {
        add
          ? this.selectedPatientDocument.timesSent += 1
          : this.selectedPatientDocument.timesSent -= 1
      }
    },

    onClickOutside() {
      if (this.selectedPatientDocument !== null) {
        this.selectedPatientDocument = null
      }
    },

    include() {
      return [document.querySelector('.included')]
    },

    async sendAll() {
      const sent = await this.$store.dispatch('alerts/sendMultipleRemindersToPatient', {
        documentIds: this.softSendIds,
        patientId : this.patientId,
        reminderType : "VIEW_EDUCATIONAL_CONTENT",
        force : true,
        forceNotify : true,
        parameterKey : "documentUuid"
      });

      if(!sent) {
        this.softSendIds.forEach(id => {
          this.toggleSentCount(id, false)
        })
      }

      this.clearAllTimeouts();
      this.$toasted.clear();
    }
  },
};
</script>

<style lang="scss">
@import "../../../../../scss/colors";

.v-knowledge-selection__details {
  font-weight: bold;
}

.v-knowledge-selection__actions {
  > a {
    color: map-get($coroColors, purple) !important;
    font-weight: bold;
    line-height: 1em;
    margin-right: 10px;
  }
}
</style>
